import { render, staticRenderFns } from "./IDard.vue?vue&type=template&id=5a1754c8&"
import script from "./IDard.vue?vue&type=script&lang=js&"
export * from "./IDard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports